import { useEffect } from "react";

import { useCart } from "@shopify/hydrogen-react";

import { onwardUpdateCartAttributes } from "@react/utilities/onwardIntegration";

export const OnwardIntegration = () => {
  const { id } = useCart();

  useEffect(() => {
    // Check if the user belongs to the Optimizely A/B test variation group
    const isOnwardVariation =
      localStorage.getItem("onwardVariationGroup") === "true";

    if (!isOnwardVariation || !id) return;

    // Register the Onward update function to the global window object for Onward's use
    window.onwardUpdateCartAttributes = onwardUpdateCartAttributes(id);

    // Set the baseline cart attribute for users in the variation group; ensures that users in the variation group start with 'onwardInsured: true' upon initialization
    window.onwardUpdateCartAttributes({
      _onwardInsured: "true",
    });

    return () => {
      window.onwardUpdateCartAttributes = undefined;
    };
  }, [id]);

  return null;
};
